/** Способ начисления стоимости опции. */
export type PackageOptionChargeType = "fixed" | "percent_of_base";

/** Опция упаковки или услуга-надбавка, начисляется на каждое место заказа. */
export type PackageOptionEntity = {
  id: number;
  name: string;
  type: string;
  price: number;
  chargeType: PackageOptionChargeType;
  dimensions: string;
  description: string;
  isActive: boolean;
  sortOrder: number;
};

export const chargeTypeTitles: Record<PackageOptionChargeType, string> = {
  fixed: "Фиксированная сумма, ₸",
  percent_of_base: "% от цены доставки места",
};

export function formatOptionPrice(option: PackageOptionEntity) {
  return option.chargeType === "percent_of_base"
    ? `+${option.price}%`
    : `${option.price} ₸`;
}
